import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import PublicLayout from "web/components/PublicLayout";

import { Container } from "web/pages/public/landing-page/LandingFooter/PrivacyPolicy/PrivacyPolicyStyled";
import LandingFooter from "..";
import { logoutAdmin } from 'redux/actions/admin';
import { logoutClearRedux } from 'redux/actions/auth';

const TermsOfUse = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const privacyPolicy = () => {
    history.push("/privacy-policy");
  };
  return (
    <>
      <Helmet title="PalletTrader | Terms of Use">
        <meta name="description"
          content="Read PalletTrader’s terms of use to understand your rights and responsibilities while using our online pallet marketplace and related services." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/terms-of-use" />
      </Helmet>
      <PublicLayout transparentHeader={true}>
        <Container>
          <h5 style={{ textAlign: "center" }}>
            <strong>Website Terms of Use</strong>
          </h5>
          <p>Last Modified: August 02, 2022</p>
          <p>
            <strong>
              1. <u>Introduction and Acceptance of the Terms of Use</u>
            </strong>
          </p>
          <p>
            These terms of use are entered into by and between you and Delancey
            Street Pallet Traders LLC d/b/a PalletTrader (&ldquo;
            <strong>PalletTrader</strong>,&rdquo; &ldquo;<strong>we</strong>
            ,&rdquo; or &ldquo;<strong>us</strong>&rdquo;). The following terms
            and conditions, together with any policies and documents they
            expressly incorporate by reference (collectively, &ldquo;
            <strong>Terms of Use</strong>&rdquo;), govern your access to and use
            of www.pallettrader.com, including any content, functionality, and
            services offered on or through <strong>www.pallettrader.com</strong>
            (the &ldquo;<strong>Website</strong>&rdquo;), whether as a guest or a
            registered user.
          </p>
          <p>
            Please read these Terms of Use carefully before you start to use the
            Website.{" "}
            <strong>
              By using or accessing the Website or using our services or by
              clicking to accept or agree to the Terms of Use when this option is
              made available to you, you accept and agree to be bound and abide by
              these Terms of Use, our Privacy Policy, found at{" "}
              <strong className="link-url" onClick={privacyPolicy}>
                Privacy Policy
              </strong>{" "}
              page, and all other policies and documents incorporated herein by
              reference.{" "}
            </strong>
            If you do not want to agree to these Terms of Use, the Privacy Policy
            and the other policies and documents incorporated herein by reference,
            you must not access or use the Website. This Website is offered and
            available to users who are 18 years of age or older and reside in the
            United States or any of its territories or possessions. By using this
            Website, you represent and warrant that you are of legal age to form a
            binding contract with PalletTrader and meet all of the foregoing
            eligibility requirements. &nbsp;If you create or use an account on
            behalf of a business entity, you represent that you are authorized to
            act on behalf of such entity and bind the entity to these Terms of
            Use. &nbsp;If you do not meet all of these requirements, you must not
            access or use the Website. &nbsp;
          </p>
          <p>
            <strong>
              Please be advised that these Terms of Use contain provisions that
              govern how claims you and we have against each other are resolved.
              &nbsp;
            </strong>
          </p>
          <p>
            <strong>
              2.&nbsp;<u>About Delancey Street Pallet Traders.</u>
            </strong>{" "}
            &nbsp;Delancey Street Pallet Traders is a neutral marketplace allowing
            you and other users to offer, sell and buy pallets and other products
            in a variety of pricing formats and locations throughout the United
            States (each, individually, a &ldquo;<strong>Transaction</strong>
            &rdquo; and, collectively, &ldquo;<strong>Transactions</strong>
            &rdquo;). &nbsp;Please be advised that each Transaction is directly
            between you and the other user.
            <strong>
              &nbsp; PALLETTRADER IS NOT A PARTY TO THE TRANSACTION AND IS NOT A
              SELLER OR A TRADITIONAL AUCTIONEER.
            </strong>
          </p>
          <p>
            Any information or guidance that we provide as part of our services to
            you (such as pricing, listing, specifications and sourcing) is solely
            informational and it is solely up to you if you choose to follow such
            information. &nbsp;While PalletTrader may help facilitate Transactions
            and the resolution of disputes, PalletTrader has no control over and
            does not guarantee the existence, quality, safety or legality of the
            pallets or other products advertised; the truth or accuracy of yours
            or any other users&rsquo; content or listings; the ability of the
            seller or buyer to consummate a Transaction; or the legal aspects of
            any Transaction. &nbsp;It is your sole responsibility, as a user of
            the Website and our services, to check the credentials of your
            counterparty and the existence, quality and safety of the pallets or
            other products involved in each Transaction.&nbsp;
          </p>
          <p>
            <strong>
              3. <u>Changes to the Terms of Use; Amendments</u>
            </strong>
          </p>
          <p>
            We may revise and update these Terms of Use from time to time in our
            sole discretion. All changes are effective immediately when we post
            them, and apply to all access to and use of the Website
            thereafter.&nbsp;
          </p>
          <p>
            Your continued use of the Website following the posting of revised
            Terms of Use means that you accept and agree to the changes. You are
            expected to check this page frequently so you are aware of any
            changes, as they are binding on you. &nbsp;
          </p>
          <p>
            <strong>
              4.&nbsp;
              <u>
                Accessing the Website; Hardware and Software Requirements; and
                Account Security
              </u>
            </strong>
          </p>
          <p>
            We reserve the right to withdraw this Website, and any service or
            material we provide on the Website, in our sole discretion without
            notice. We will not be liable if for any reason all or any part of the
            Website is unavailable at any time or for any period. From time to
            time, we may restrict access to some parts of the Website, or the
            entire Website, to users, including registered users.
          </p>
          <p>You are responsible for:</p>
          <ul>
            <li style={{ lineHeight: 2 }}>
              Making all arrangements necessary for you to have access to the
              Website and
            </li>
            <li style={{ lineHeight: 2 }}>
              Ensuring that all persons who access the Website through your
              internet connection are aware of these Terms of Use and comply with
              them and shall be responsible for any breach of these Terms of Use
              by such person as if such person was a party hereto.
            </li>
          </ul>
          <p>
            In addition, you are responsible for purchasing, operating, and
            maintaining all equipment necessary to use the Website including,
            without limitation, all wireless and internet services necessary to
            access the Website and for charges arising out of or related to those
            services. &nbsp;In addition, we may impose additional hardware and
            software requirements and mandatory equipment maintenance procedures
            from time to time by notifying you, and, you agree to abide by such
            requirements and procedures at your expense. &nbsp;We reserve the
            right to add to, change or delete the hardware, software and other
            service requirements from time to time by providing notice to you in
            accordance with these Terms of Use.&nbsp;
          </p>
          <p>
            To access the Website or some of the resources it offers, you may be
            asked to provide certain registration details or other information. It
            is a condition of your use of the Website that all the information you
            provide on the Website is correct, current, and complete. You agree
            that all information you provide to register with this Website or
            otherwise including, but not limited to, through the use of any
            interactive features on the Website, is governed by our{" "}
            <strong className="link-url" onClick={privacyPolicy}>
              Privacy Policy,
            </strong>{" "}
            and you consent to all actions we take with respect to your
            information consistent with our Privacy Policy.
          </p>
          <p>
            If you choose, or are provided with, a user name, password, or any
            other piece of information as part of our security procedures, you
            must treat such information as confidential, and you must not disclose
            it to any other person or entity. You also acknowledge that your
            account is personal to you and agree not to provide any other person
            with access to this Website or portions of it using your user name,
            password, or other security information. You agree to notify us
            immediately of any unauthorized access to or use of your user name or
            password or any other breach of security. You will not allow
            non-registered people or entities access to our services and will
            never provide your password to any non-registered people or entities
            nor will you share any information from the Website with any
            non-authorized users. You also agree to ensure that you exit from your
            account at the end of each session. You should use particular caution
            when accessing your account from a public or shared computer so that
            others are not able to view or record your password or other personal
            information.
          </p>
          <p>
            We have the right to disable any user name, password, or other
            identifier, whether chosen by you or provided by us, at any time in
            our sole discretion for any or no reason including, without
            limitation, if, in our opinion, you have violated any provision of
            these Terms of Use.
          </p>
          <p>
            <strong>
              5.&nbsp;<u>Intellectual Property Rights</u>
            </strong>
          </p>
          <p>
            The Website and its entire contents, features, and functionality
            (including, but not limited to, all information, software, text,
            displays, images, video, and audio, and the design, selection, and
            arrangement thereof) are owned by PalletTrader, its licensors, or
            other providers of such material and are protected by United States
            and international copyright, trademark, patent, trade secret, and
            other intellectual property or proprietary rights laws.
          </p>
          <p>
            These Terms of Use permit you to use the Website for your personal,
            non-commercial use only. You must not reproduce, distribute, modify,
            create derivative works of, publicly display, publicly perform,
            republish, download, store, or transmit any of the material on our
            Website, except as follows:
          </p>
          <ul>
            <li style={{ lineHeight: 2 }}>
              Your computer may temporarily store copies of such materials in RAM
              incidental to your accessing and viewing those materials.
            </li>
            <li style={{ lineHeight: 2 }}>
              You may store files that are automatically cached by your Web
              browser for display enhancement purposes.
            </li>
            <li style={{ lineHeight: 2 }}>
              You may print one copy of a reasonable number of pages of the
              Website for your own personal, non-commercial use and not for
              further reproduction, publication, or distribution.
            </li>
            <li style={{ lineHeight: 2 }}>
              If we provide desktop, mobile, or other applications for download,
              you may download a single copy to your computer or mobile device
              solely for your own personal, non-commercial use, provided you agree
              to be bound by our end user license agreement for such
              applications.&nbsp;
            </li>
            <li style={{ lineHeight: 2 }}>
              If we provide Social Media Features with certain content, you may
              take such actions as are enabled by such features.
            </li>
          </ul>
          <p>You must not:</p>
          <ul>
            <li style={{ lineHeight: 2 }}>
              Modify copies of any materials from this site.
            </li>
            <li style={{ lineHeight: 2 }}>
              Use any illustrations, photographs, video or audio sequences, or any
              graphics separately from the accompanying text.
            </li>
            <li style={{ lineHeight: 2 }}>
              Delete or alter any copyright, trademark, or other proprietary
              rights notices from copies of materials from the Website.
            </li>
            <li style={{ lineHeight: 2 }}>
              Access or use for any commercial purposes any part of the Website or
              any services or materials available through the Website including,
              without limitation, competing with PalletTrader with respect to the
              services offered on or through the Website.{" "}
            </li>
          </ul>
          <p>
            If you wish to make any use of material on the Website other than that
            set out in this section, please contact us at:
            &nbsp;support@pallettrader.com.
          </p>
          <p>
            If you print, copy, modify, download, or otherwise use or provide any
            other person with access to any part of the Website in breach of the
            Terms of Use, your right to use the Website will stop immediately and
            you must, at our option, return or destroy any copies of the materials
            you have made.&nbsp;
          </p>
          <p>
            No right, title, or interest in or to the Website or any content on
            the Website is transferred to you, and all rights not expressly
            granted are reserved by PalletTrader. Any use of the Website not
            expressly permitted by these Terms of Use is a breach of these Terms
            of Use and may violate copyright, trademark, and other laws.
          </p>
          <p>
            <strong>
              6. <u>Trademarks</u>
            </strong>
          </p>
          <p>
            The PalletTrader name, the PalletTrader trademarks, the PalletTrader
            logo, and all related names, logos, product and service names,
            graphics, designs, and slogans are trademarks of PalletTrader or its
            affiliates or licensors (collectively, the &ldquo;
            <strong>Marks</strong>&rdquo;). You must not use, copy, reproduce,
            republish, or modify such Marks without the prior written consent of
            PalletTrader. All other names, logos, product and service names,
            designs, and slogans on this Website are the trademarks of their
            respective owners.
          </p>
          <p>
            <strong>
              7. <u>Software</u>
            </strong>
          </p>
          <p>
            The following terms apply to any and all software (including updates
            and upgrades to such software and any related documentation) we make
            available to you in connection with the Website (the &ldquo;
            <strong>PalletTrader Software</strong>&rdquo;): &nbsp;You may use the
            PalletTrader Software solely for purposes of enabling you to use the
            Website as provided by PalletTrader and as permitted by these Terms of
            Use and by the Terms and Conditions for Buyers and Sellers (the
            &ldquo;<strong>Terms and Conditions</strong>&rdquo;). &nbsp;You may
            not incorporate any portion of the PalletTrader Software into other
            programs or compile any portion of the PalletTrader Software in
            combination with other programs or otherwise copy, modify, create
            derivative works of, or distribute the PalletTrader Software in whole
            or part. &nbsp;The PalletTrader Software is the property of
            PalletTrader or PalletTrader&rsquo;s software supplier and is
            protected by United States and international copyright laws. &nbsp;You
            may not reverse engineer, decompile, disassemble, tamper with, or
            bypass any security associated with the PalletTrader Software, in
            whole or in part.
          </p>
          <p>
            <strong>
              8. <u>Prohibited Uses</u>
            </strong>
          </p>
          <p>
            As previously stated, you may use the Website only for lawful purposes
            and in accordance with these Terms of Use. &nbsp;In addition to the
            other restrictions contained in these Terms of Use, you agree not to
            use the Website:
          </p>
          <ul>
            <li style={{ lineHeight: 2 }}>
              In any way that violates any applicable federal, state, local, or
              international law or regulation (including, without limitation, any
              laws regarding the export of data or software to and from the United
              States or other countries, any laws concerning import and export of
              goods, the Foreign Corrupt Practices Act and other laws prohibiting
              bribery, discrimination, forced or involuntary labor and equal
              opportunity in employment).&nbsp;
            </li>
            <li style={{ lineHeight: 2 }}>
              For the purpose of exploiting, harming, or attempting to exploit or
              harm minors in any way by exposing them to inappropriate content,
              asking for personally identifiable information, or otherwise.
            </li>
            <li style={{ lineHeight: 2 }}>
              To send, knowingly receive, upload, download, use, or re-use any
              material that does not comply with the section titled &ldquo;Content
              Standards&rdquo; set out in these Terms of Use.
            </li>
            <li style={{ lineHeight: 2 }}>
              To transmit, or procure the sending of, any advertising or
              promotional material without our prior written consent, including
              any &ldquo;junk mail,&rdquo; &ldquo;chain letter,&rdquo;
              &ldquo;spam,&rdquo; or any other similar solicitation.
            </li>
            <li style={{ lineHeight: 2 }}>
              To impersonate or attempt to impersonate PalletTrader, a
              PalletTrader employee, another user, or any other person or entity
              (including, without limitation, by using email addresses or screen
              names associated with any of the foregoing).
            </li>
            <li style={{ lineHeight: 2 }}>
              To engage in any other conduct that restricts or inhibits
              anyone&rsquo;s use or enjoyment of the Website, or which, as
              determined by us in our sole discretion, may harm PalletTrader or
              users of the Website, or expose them to liability.
            </li>
            <li style={{ lineHeight: 2 }}>
              In any manner that could disable, overburden, damage, or impair the
              Website or interfere with any other party&rsquo;s use of the
              Website, including their ability to engage in real time activities
              through the Website.
            </li>
            <li style={{ lineHeight: 2 }}>
              To manipulate the price of any pallet or interfere with any other
              user&rsquo;s listings.
            </li>
            <li style={{ lineHeight: 2 }}>
              To take any action that may undermine the feedback or ratings
              systems.
            </li>
            <li style={{ lineHeight: 2 }}>
              To engage in any action with another user on the Website designed to
              complete or facilitate a Transaction outside of the Website
              including, without limitation, referring to or promoting external
              websites that facilitate sales outside of the Website.&nbsp;
            </li>
            <li style={{ lineHeight: 2 }}>
              To engage in the trading of rental pallets.
            </li>
            <li style={{ lineHeight: 2 }}>
              &nbsp;To harvest or otherwise collect information about other users
              without their consent.&nbsp;
            </li>
            <li style={{ lineHeight: 2 }}>
              In addition, you agree that you will not:
            </li>
            <li style={{ lineHeight: 2 }}>
              Use any robot, spider, or other automatic device, process, or means
              to access the Website for any purpose, including monitoring or
              copying any of the material on the Website.
            </li>
            <li style={{ lineHeight: 2 }}>
              Use any manual process to monitor or copy any of the material on the
              Website, or for any other purpose not expressly authorized in these
              Terms of Use, without our prior written consent.
            </li>
            <li style={{ lineHeight: 2 }}>
              Introduce any viruses, Trojan horses, worms, logic bombs, or other
              material that is malicious or technologically harmful.
            </li>
            <li style={{ lineHeight: 2 }}>
              Attempt to gain unauthorized access to, interfere with, damage, or
              disrupt any parts of the Website, the server on which the Website is
              stored, or any server, computer, or database connected to the
              Website.&nbsp;
            </li>
            <li style={{ lineHeight: 2 }}>
              Attack the Website via a denial-of-service attack or a distributed
              denial-of-service attack.
            </li>
            <li style={{ lineHeight: 2 }}>
              Otherwise attempt to interfere with the proper working of the
              Website.
            </li>
          </ul>
          <p>
            <strong>
              9. <u>User Contributions</u>
            </strong>
          </p>
          <p>
            The Website may contain message boards, chat rooms, personal web pages
            or profiles, forums, bulletin boards, and other interactive features
            (collectively, &ldquo;<strong>Interactive Services</strong>&rdquo;)
            that allow users to post, submit, publish, display, or transmit to
            other users or other persons (hereinafter, &ldquo;post&rdquo;) content
            or materials (collectively, &ldquo;<strong>User Contributions</strong>
            &rdquo;) on or through the Website.
          </p>
          <p>
            All User Contributions must comply with the Content Standards set out
            in these Terms of Use.
          </p>
          <p>
            Any User Contribution you post to the Website will be considered
            non-confidential and non-proprietary. By providing any User
            Contribution on the Website, you grant us and our affiliates and
            service providers, and each of their and our respective licensees,
            successors, and assigns a non-exclusive, worldwide, perpetual,
            irrevocable, royalty-free, sublicensable right to use, reproduce,
            modify, perform, display, distribute, and otherwise disclose to third
            parties any such material for any purpose, in any media known now or
            developed in the future. &nbsp;To the fullest extent permitted under
            applicable law, you waive your right to enforce your intellectual
            property rights in any User Contribution against us and our affiliates
            and service providers, and each of their and our respective licensees,
            successors, and assigns in connection with our provision, expansion
            and promotion of the Website.&nbsp;
          </p>
          <p>You represent and warrant that:&nbsp;</p>
          <ul>
            <li style={{ lineHeight: 2 }}>
              You own or control all rights in and to the User Contributions and
              have the right to grant the license granted above to us and our
              affiliates and service providers, and each of their and our
              respective licensees, successors, and assigns.
            </li>
            <li style={{ lineHeight: 2 }}>
              All of your User Contributions do and will comply with these Terms
              of Use.{" "}
            </li>
          </ul>
          <p>
            You understand and acknowledge that you are responsible for any User
            Contributions you submit or contribute, and you, not PalletTrader,
            have full responsibility for such content, including its legality,
            reliability, accuracy, and appropriateness.
          </p>
          <p>
            We are not responsible or liable in any way to any third party for,
            and we do not guarantee to any third party, the content, accuracy,
            integrity or quality of, any User Contributions posted by you or any
            other user of the Website. &nbsp;We cannot assure that harmful,
            inaccurate, misleading, deceptive, offensive, threatening, unlawful or
            otherwise objectionable User Contributions will not appear on the
            Website.
          </p>
          <p>
            <strong>
              10. <u>Monitoring and Enforcement; Termination</u>
            </strong>
          </p>
          <p>
            Notwithstanding anything to the contrary in these Terms of Use, we
            have the right to:
          </p>
          <ul>
            <li style={{ lineHeight: 2 }}>
              Remove or refuse to post any User Contributions for any or no reason
              in our sole discretion.
            </li>
            <li style={{ lineHeight: 2 }}>
              Take any action with respect to any User Contribution that we deem
              necessary or appropriate in our sole discretion including, without
              limitation, if we believe that such User Contribution violates the
              Terms of Use (including, without limitation, the Content Standards),
              infringes any intellectual property right or other right of any
              person or entity, threatens the personal safety of users of the
              Website or the public, or could create liability for PalletTrader.
            </li>
            <li style={{ lineHeight: 2 }}>
              Disclose your identity or other information about you to any third
              party who claims that material posted by you violates their rights
              including, without limitation, their intellectual property rights or
              their right to privacy.
            </li>
            <li style={{ lineHeight: 2 }}>
              Take appropriate legal action for any illegal or unauthorized use of
              the Website.&nbsp;
            </li>
            <li style={{ lineHeight: 2 }}>
              Terminate or suspend your access to all or part of the Website for
              any or no reason including, without limitation, any violation of
              these Terms of Use or if you are abusing PalletTrader and/or our
              services in any way. &nbsp;We may also terminate unconfirmed
              accounts or accounts that have been inactive for a substantial
              period of time.{" "}
            </li>
          </ul>
          <p>
            Without limiting the foregoing, we have the right to cooperate fully
            with any law enforcement authorities or court order requesting or
            directing us to disclose the identity or other information of anyone
            posting any materials on or through the Website. YOU WAIVE AND HOLD
            HARMLESS PALLETTRADER AND ITS AFFILIATES, LICENSEES, AND SERVICE
            PROVIDERS FROM ANY CLAIMS RESULTING FROM ANY ACTION TAKEN BY ANY OF
            THE FOREGOING PARTIES DURING, OR TAKEN AS A CONSEQUENCE OF,
            INVESTIGATIONS BY EITHER SUCH PARTIES OR LAW ENFORCEMENT AUTHORITIES.
          </p>
          <p>
            You acknowledge that we do not undertake to review all material before
            it is posted on the Website, and cannot ensure prompt removal of
            objectionable material after it has been posted. Accordingly, we
            assume no liability for any action or inaction regarding
            transmissions, communications, or content provided by any user or
            third party. We have no liability or responsibility to anyone for
            performance or nonperformance of the activities described in this
            section. PalletTrader expressly disclaims any and all responsibility
            for the content, information, links and other items, the accuracy and
            completeness of the information, and the quality of products or
            services made available or advertised on any site, forum or medium not
            owned by PalletTrader. &nbsp;PalletTrader does not control, endorse,
            promote or have any affiliation with any other website, individual, or
            entity unless expressly stated herein.&nbsp;
          </p>
          <p>
            <strong>
              11. <u>Content Standards</u>
            </strong>
          </p>
          <p>
            These content standards apply to any and all User Contributions and
            use of Interactive Services. User Contributions must in their entirety
            comply with all applicable federal, state, local, and international
            laws and regulations. Without limiting the foregoing, User
            Contributions must not:
          </p>
          <ul>
            <li>
              Contain any material that is defamatory, obscene, indecent, abusive,
              offensive, harassing, violent, hateful, inflammatory, or otherwise
              objectionable.
            </li>
            <li>
              Promote sexually explicit or pornographic material, violence, or
              discrimination based on race, sex, religion, nationality,
              disability, sexual orientation, or age.
            </li>
            <li>
              Infringe any patent, trademark, trade secret, copyright, or other
              intellectual property or other rights of any other person or entity.
            </li>
            <li>
              Violate the legal rights (including the rights of publicity and
              privacy) of others or contain any material that could give rise to
              any civil or criminal liability under applicable laws or regulations
              or that otherwise may be in conflict with these Terms of Use or our{" "}
              <strong className="link-url" onClick={privacyPolicy}>
                Privacy Policy,
              </strong>{" "}
              .
            </li>
            <li>Be likely to deceive any person.</li>
            <li>
              Promote any illegal activity, or advocate, promote, or assist any
              unlawful act.
            </li>
            <li>
              Cause annoyance, inconvenience, or needless anxiety or be likely to
              upset, embarrass, alarm, or annoy any other person.
            </li>
            <li>
              Impersonate any person, or misrepresent your identity or affiliation
              with any person or organization.&nbsp;
            </li>
            <li>
              Involve contests, sweepstakes, and other sales promotions, barter,
              or advertising.
            </li>
            <li>
              Give the impression that they emanate from or are endorsed by us or
              any other person or entity, if this is not the case.
            </li>
          </ul>
          <p>
            <strong>
              12. <u>Copyright Policy</u>
            </strong>
          </p>
          <p>
            <strong>Reporting Claims of Copyright Infringement</strong>
          </p>
          <p>
            We take claims of copyright infringement seriously. Accordingly, we
            will respond to notices of alleged copyright infringement that comply
            with applicable law. &nbsp;If you believe any materials accessible on
            or from the Website including, without limitation, User Contributions,
            infringe your copyright, you may request removal of those materials
            (or access to them) from the Website by submitting written
            notification to our copyright agent designated below. &nbsp;In
            accordance with the Online Copyright Infringement Liability Limitation
            Act of the Digital Millennium Copyright Act (17 U.S.C. &sect; 512)
            (&ldquo;<strong>DMCA</strong>&rdquo;), the written notice (the &ldquo;
            <strong>DMCA Notice</strong>&rdquo;) must include substantially the
            following:
          </p>
          <ul>
            <li style={{ lineHeight: 2 }}>
              Your physical or electronic signature.
            </li>
            <li style={{ lineHeight: 2 }}>
              Identification of the copyrighted work you believe to have been
              infringed or, if the claim involves multiple works on the Website, a
              representative list of such works.
            </li>
            <li style={{ lineHeight: 2 }}>
              Identification of the material you believe to be infringing in a
              sufficiently precise manner to allow us to locate that material.
            </li>
            <li style={{ lineHeight: 2 }}>
              Adequate information by which we can contact you (including your
              name, postal address, telephone number, and, if available, email
              address).
            </li>
            <li style={{ lineHeight: 2 }}>
              A statement that you have a good faith belief that use of the
              copyrighted material is not authorized by the copyright owner, its
              agent, or the law.
            </li>
            <li style={{ lineHeight: 2 }}>
              A statement that the information in the written notice is accurate.
            </li>
            <li style={{ lineHeight: 2 }}>
              A statement, under penalty of perjury, that you are authorized to
              act on behalf of the copyright owner.
            </li>
          </ul>
          <p>
            Our designated copyright agent (&ldquo;
            <strong>Copyright Agent</strong>&rdquo;) to receive DMCA Notices is:
            Charles Skop, Esq., Meyer Suozzi English &amp; Klein, P.C., 990
            Stewart Avenue, Suite 300, Garden City, New York &nbsp;11530, Phone
            number: &nbsp;(516) 592-5921, email: &nbsp;cskop@msek.com.
          </p>
          <p>
            If you fail to comply with all of the requirements of Section
            512(c)(3) of the DMCA, your DMCA Notice may not be effective.
          </p>
          <p>
            Please be aware that if you knowingly materially misrepresent that
            material or activity on the Website is infringing your copyright, you
            may be held liable for damages (including, without limitation, costs
            and attorneys&rsquo; fees) under Section 512(f) of the DMCA.&nbsp;
          </p>
          <p>
            <strong>Counter Notification Procedures</strong>
          </p>
          <p>
            If you believe that material you posted on the Website was removed or
            access to it was disabled by mistake or misidentification, you may
            file a counter notification with us (a &ldquo;Counter Notice&rdquo;)
            by submitting written notification to our copyright agent listed
            above. &nbsp;Pursuant to the DMCA, the Counter Notice must include
            substantially the following:
          </p>
          <ul>
            <li style={{ lineHeight: 2 }}>
              Your physical or electronic signature.
            </li>
            <li style={{ lineHeight: 2 }}>
              An identification of the material that has been removed or to which
              access has been disabled and the location at which the material
              appeared before it was removed or access disabled.
            </li>
            <li style={{ lineHeight: 2 }}>
              Adequate information by which we can contact you (including your
              name, postal address, telephone number, and, if available, email
              address).
            </li>
            <li style={{ lineHeight: 2 }}>
              A statement, under penalty of perjury, by you that you have a good
              faith belief that the material identified above was removed or
              disabled as a result of a mistake or misidentification of the
              material to be removed or disabled.
            </li>
            <li style={{ lineHeight: 2 }}>
              A statement that you will consent to the jurisdiction of the Federal
              District Court for the judicial district in which your address is
              located (or if you reside outside the United States for any judicial
              district in which the Website may be found) and that you will accept
              service from the person (or an agent of that person) who provided
              the Website with the complaint at issue.
            </li>
          </ul>
          <p>
            The DMCA allows us to restore the removed content if the party filing
            the DMCA Notice does not file a court action against you within ten
            (10) business days of receiving the copy of your Counter Notice.&nbsp;
          </p>
          <p>
            Please be aware that if you knowingly materially misrepresent that
            material or activity on the Website was removed or disabled by mistake
            or misidentification, you may be held liable for damages (including
            costs and attorneys&rsquo; fees) under Section 512(f) of the DMCA.
          </p>
          <p>
            <strong>Repeat Infringers</strong>
          </p>
          <p>
            It is our policy in appropriate circumstances to disable and/or
            terminate the accounts of users who are repeat infringers.&nbsp;
          </p>
          <p>
            <strong>
              13. <u>Reliance on Information Posted</u>
            </strong>
          </p>
          <p>
            We try to offer reliable product data but cannot and do not promise
            that the information provided on or through the Website will always be
            available, accurate, complete and up-to-date. &nbsp;Instead, the
            information presented on or through the Website is made available
            solely for general information purposes. We do not warrant the
            accuracy, completeness, or usefulness of this information. Any
            reliance you place on such information is strictly at your own risk.
            We disclaim all liability and responsibility arising from any reliance
            placed on such materials by you or any other visitor to the Website or
            by anyone who may be informed of any of its contents. &nbsp;You agree
            that PalletTrader is not responsible for examining or warranting the
            listings or content provided by third parties on or through the
            Website and that you will not attempt to hold us liable for any
            inaccuracies.&nbsp;
          </p>
          <p>
            The Website may include content provided by third parties, including
            materials provided by other users, bloggers, and third-party
            licensors, syndicators, aggregators, and/or reporting services. All
            statements and/or opinions expressed in these materials, and all
            articles and responses to questions and other content, other than the
            content provided by PalletTrader, are solely the opinions and the
            responsibility of the person or entity providing those materials.
            These materials do not necessarily reflect the opinion of
            PalletTrader. We are not responsible, or liable to you or any third
            party, for the content or accuracy of any materials provided by any
            third parties.
          </p>
          <p>
            <strong>
              14. <u>Changes to the Website</u>
            </strong>
          </p>
          <p>
            We may update the content on this Website from time to time, but its
            content is not necessarily complete or up-to-date. Any of the material
            on the Website may be out of date at any given time, and we are under
            no obligation to update such material.&nbsp;
          </p>
          <p>
            <strong>
              15. <u>Information About You and Your Visits to the Website</u>
            </strong>
          </p>
          <p>
            All information we collect on this Website is subject to our{" "}
            <strong className="link-url" onClick={privacyPolicy}>
              Privacy Policy,
            </strong>{" "}
            By using the Website, you consent to all actions taken by us with
            respect to your information in compliance with the Privacy
            Policy.&nbsp;
          </p>
          <p>
            <strong>
              16. <u>Privacy Policy</u>
            </strong>
          </p>
          <p>
            We respect your privacy and security and our goal is to provide you
            with a Website that delivers the information, resources and services
            that are relevant and helpful to you. &nbsp;In order to do so, we may
            collect information about you or that you may provide when you visit
            the Website. &nbsp;Our full Privacy Policy and our Payment
            Entity&rsquo;s (as defined below) and our and their practices for
            collecting, using, maintaining, protecting and disclosing such
            information is set forth at{" "}
            <strong className="link-url" onClick={privacyPolicy}>
              Privacy Policy,
            </strong>{" "}
            and <strong>https://stripe.com/privacy</strong>
          </p>
          <p>
            <strong>
              17. <u>Managed Payments </u>
            </strong>
          </p>
          <p>
            A designated entity (the &ldquo;<strong>Payment Entity</strong>
            &rdquo;) manages payments for all Transactions. &nbsp;The Payment
            Entity is currently Stripe, Inc. &nbsp;PalletTrader may change the
            Payment Entity from time to time. &nbsp;Regardless of whether or not
            PalletTrader or the Payment Entity manages a Transaction, each
            Transaction is directly concluded between the seller and the buyer,
            and PalletTrader is not a party to any Transaction.
          </p>
          <p>
            In order to use such managed payments services, and to continue to
            engage in Transactions on the Website, you must, or you must authorize
            us to:
          </p>
          <ul>
            <li style={{ lineHeight: 2 }}>
              Provide the Payment Entity with information about you and/or your
              business to meet its compliance requirements including, those
              involving identity verification, anti-money laundering controls and
              sanctions screening as required by applicable law and its policies.
            </li>
            <li style={{ lineHeight: 2 }}>
              Satisfy the Payment Entity&rsquo;s verification, screening and other
              compliance requirements as determined by the Payment Entity.
            </li>
            <li style={{ lineHeight: 2 }}>
              Provide bank account information for a United States-based checking
              account so that the Payment Entity can link such checking account to
              your account.
            </li>
          </ul>
          <p>
            <strong>18.&nbsp;</strong>
            <strong>
              <u>Holds and Restricted Funds</u>
            </strong>
          </p>
          <p>
            To protect us from risk of liability for your actions as a seller, we
            or the Payment Entity may restrict access to your funds as described
            in the Terms and Conditions for Buyers and Sellers found upon the
            login to the website under Operational T &amp; C&rsquo;s
          </p>
          <p>
            <strong>
              19. <u>Returns and Cancellations</u>
            </strong>
          </p>
          <p>
            All returns and cancellations of any order on the Website must be made
            in accordance with our Terms and Conditions for Buyers and Sellers
            found upon the login to the website under Operational T &amp;
            C&rsquo;s
          </p>
          <p>
            <strong>Linking to the Website and Social Media Features</strong>
          </p>
          <p>
            You may link to our homepage, provided you do so in a way that is fair
            and legal and does not damage our reputation or take advantage of it,
            but you must not establish a link in such a way as to suggest any form
            of association, approval, or endorsement on our part without our
            express written consent.
          </p>
          <p>
            This Website may provide certain social media features that enable you
            to:
          </p>
          <ul>
            <li style={{ lineHeight: 2 }}>
              Link from your own or certain third-party websites to certain
              content on this Website.
            </li>
            <li style={{ lineHeight: 2 }}>
              Send emails or other communications with certain content, or links
              to certain content, on this Website.
            </li>
            <li style={{ lineHeight: 2 }}>
              Cause limited portions of content on this Website to be displayed or
              appear to be displayed on your own or certain third-party websites.
            </li>
          </ul>
          <p>
            You may use these features solely as they are provided by us and
            solely with respect to the content they are displayed with, and
            otherwise in accordance with any additional terms and conditions we
            provide with respect to such features. Subject to the foregoing, you
            must not:
          </p>
          <ul>
            <li style={{ lineHeight: 2 }}>
              Establish a link from any website that is not owned by you.
            </li>
            <li style={{ lineHeight: 2 }}>
              Cause the Website or portions of it to be displayed on, or appear to
              be displayed by, any other site, for example, framing, deep linking,
              or in-line linking.
            </li>
            <li style={{ lineHeight: 2 }}>
              Link to any part of the Website other than the homepage.
            </li>
            <li style={{ lineHeight: 2 }}>
              Otherwise take any action with respect to the materials on this
              Website that is inconsistent with any other provision of these Terms
              of Use.
            </li>
          </ul>
          <p>
            The website from which you are linking, or on which you make certain
            content accessible, must comply in all respects with the Content
            Standards set out in these Terms of Use.
          </p>
          <p>
            You agree to cooperate with us in causing any unauthorized framing or
            linking immediately to stop. We reserve the right to withdraw linking
            permission without notice.
          </p>
          <p>
            We may disable all or any social media features and any links at any
            time without notice in our discretion.&nbsp;
          </p>
          <p>
            <strong>20. </strong>
            <strong>
              <u>Links from the Website</u>
            </strong>
          </p>
          <p>
            If the Website contains links to other sites and resources provided by
            third parties, these links are provided for your convenience only.
            This includes links contained in advertisements, including banner
            advertisements and sponsored links. We have no control over the
            contents of those sites or resources, and accept no responsibility for
            them or for any loss or damage that may arise from your use of them.
            If you decide to access any of the third-party websites linked to this
            Website, you do so entirely at your own risk and subject to the terms
            and conditions of use for such websites.
          </p>
          <p>
            <strong>
              20. <u>Geographic Restrictions</u>
            </strong>
          </p>
          <p>
            The owner of the Website is based in the State of New Jersey in the
            United States. We provide this Website for use only by persons located
            in the United States. We make no claims that the Website or any of its
            content is accessible or appropriate outside of the United States.
            Access to the Website may not be legal by certain persons or in
            certain countries. If you access the Website from outside the United
            States, you do so on your own initiative and are responsible for
            compliance with local laws.
          </p>
          <p>
            <strong>
              22. <u>Disclaimer of Warranties</u>
            </strong>
          </p>
          <p>
            You understand that we cannot and do not guarantee or warrant that
            files available for downloading from the internet or the Website will
            be free of viruses or other destructive code. You are responsible for
            implementing sufficient procedures and checkpoints to satisfy your
            particular requirements for anti-virus protection and accuracy of data
            input and output, and for maintaining a means external to our site for
            any reconstruction of any lost data. TO THE FULLEST EXTENT PROVIDED BY
            LAW, WE WILL NOT BE LIABLE FOR ANY LOSS OR DAMAGE CAUSED BY A
            DISTRIBUTED DENIAL-OF-SERVICE ATTACK, VIRUSES, OR OTHER
            TECHNOLOGICALLY HARMFUL MATERIAL THAT MAY INFECT YOUR COMPUTER
            EQUIPMENT, COMPUTER PROGRAMS, DATA, OR OTHER PROPRIETARY MATERIAL DUE
            TO YOUR USE OF THE WEBSITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH
            THE WEBSITE OR TO YOUR DOWNLOADING OF ANY MATERIAL POSTED ON IT, OR ON
            ANY WEBSITE LINKED TO IT.
          </p>
          <p>
            YOUR USE OF THE WEBSITE, ITS CONTENT, AND ANY SERVICES OR ITEMS
            OBTAINED THROUGH THE WEBSITE IS AT YOUR OWN RISK. THE WEBSITE, ITS
            CONTENT, AND ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE ARE
            PROVIDED ON AN &ldquo;AS IS&rdquo; AND &ldquo;AS AVAILABLE&rdquo;
            BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.
            NEITHER PALLETTRADER NOR ANY PERSON ASSOCIATED WITH PALLETTRADER MAKES
            ANY WARRANTY OR REPRESENTATION WITH RESPECT TO THE COMPLETENESS,
            SECURITY, RELIABILITY, QUALITY, ACCURACY, OR AVAILABILITY OF THE
            WEBSITE. WITHOUT LIMITING THE FOREGOING, NEITHER PALLETTRADER NOR
            ANYONE ASSOCIATED WITH PALLETTRADER REPRESENTS OR WARRANTS THAT THE
            WEBSITE, ITS CONTENT, OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE
            WEBSITE WILL BE ACCURATE, RELIABLE, ERROR-FREE, OR UNINTERRUPTED, THAT
            DEFECTS WILL BE CORRECTED, THAT OUR SITE OR THE SERVER THAT MAKES IT
            AVAILABLE ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS, OR THAT THE
            WEBSITE OR ANY SERVICES OR ITEMS OBTAINED THROUGH THE WEBSITE WILL
            OTHERWISE MEET YOUR NEEDS OR EXPECTATIONS.&nbsp;
          </p>
          <p>
            TO THE FULLEST EXTENT PROVIDED BY LAW, PALLETTRADER HEREBY DISCLAIMS
            ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, STATUTORY, OR
            OTHERWISE INCLUDING, BUT NOT LIMITED TO ANY WARRANTIES OF
            MERCHANTABILITY, NON-INFRINGEMENT, AND FITNESS FOR PARTICULAR PURPOSE.
          </p>
          <p>
            THE FOREGOING DOES NOT AFFECT ANY WARRANTIES THAT CANNOT BE EXCLUDED
            OR LIMITED UNDER APPLICABLE LAW.
          </p>
          <p>
            <strong>
              23. <u>Limitation on Liability</u>
            </strong>
          </p>
          <p>
            TO THE FULLEST EXTENT PROVIDED BY LAW, IN NO EVENT WILL PALLETTRADER,
            ITS SUBSIDIARIES AND AFFILIATES, OR ITS OR THEIR LICENSORS, SERVICE
            PROVIDERS, EMPLOYEES, AGENTS, OFFICERS, OR DIRECTORS BE LIABLE FOR
            DAMAGES OF ANY KIND, UNDER ANY LEGAL THEORY, ARISING OUT OF OR IN
            CONNECTION WITH YOUR USE, OR INABILITY TO USE, THE WEBSITE, ANY
            WEBSITES LINKED TO IT, ANY CONTENT ON THE WEBSITE OR SUCH OTHER
            WEBSITES, INCLUDING ANY DIRECT, INDIRECT, SPECIAL, INCIDENTAL,
            CONSEQUENTIAL, OR PUNITIVE DAMAGES INCLUDING, BUT NOT LIMITED TO,
            PERSONAL INJURY, PAIN AND SUFFERING, EMOTIONAL DISTRESS, LOSS OF
            REVENUE, LOSS OF PROFITS, LOSS OF BUSINESS OR ANTICIPATED SAVINGS,
            LOSS OF USE, LOSS OF GOODWILL, LOSS OF DATA, AND WHETHER CAUSED BY
            TORT (INCLUDING NEGLIGENCE), BREACH OF CONTRACT, OR OTHERWISE, EVEN IF
            FORESEEABLE.&nbsp;
          </p>
          <p>
            THE FOREGOING DOES NOT AFFECT ANY LIABILITY THAT CANNOT BE EXCLUDED OR
            LIMITED UNDER APPLICABLE LAW.
          </p>
          <p>
            IN NO EVENT SHALL PALLETTRADER&rsquo;S CUMULATIVE LIABILITY UNDER
            THESE TERMS OF USE EXCEED THE LESSER OF: &nbsp;(A) THE TOTAL FEES PAID
            BY YOU TO PALLETTRADER DURING THE PRECEDING SIX (6) MONTHS; OR, (B)
            ONE THOUSAND DOLLARS ($1,000.00).
          </p>
          <p>
            <strong>
              24. <u>Release</u>
            </strong>
          </p>
          <p>
            If you have a dispute with one or more users, you release us (and our
            affiliates and subsidiaries, and our and their respective officers,
            directors, employees, contractors, and agents) from claims, demands
            and damages (actual and consequential) of every kind and nature, known
            and unknown, arising out of or in any way connected with such
            disputes. &nbsp;IN ENTERING INTO THIS RELEASE YOU EXPRESSLY WAIVE ANY
            PROTECTIONS (WHETHER STATUTORY OR OTHERWISE) THAT WOULD OTHERWISE
            LIMIT THE COVERAGE OF THIS RELEASE TO INCLUDE ONLY THOSE CLAIMS WHICH
            YOU MAY KNOW OR SUSPECT TO EXIST IN YOUR FAVOR AT THE TIME OF AGREEING
            TO THIS RELEASE.
          </p>
          <p>
            <strong>
              25. <u>Indemnification</u>
            </strong>
          </p>
          <p>
            You agree to defend, indemnify, and hold harmless PalletTrader, its
            affiliates, licensors, and service providers, and its and their
            respective officers, directors, employees, contractors, agents,
            licensors, suppliers, successors, and assigns from and against any
            claims, liabilities, damages, judgments, awards, losses, costs,
            expenses, or fees (including reasonable attorneys&rsquo; fees) arising
            out of or relating to your violation of these Terms of Use or your use
            of the Website including, without limitation, your User Contributions,
            any use of the Website&rsquo;s content, services, and products other
            than as expressly authorized in these Terms of Use, or your use of any
            information obtained from the Website.
          </p>
          <p>
            <strong>
              26. <u>Governing Law and Jurisdiction</u>
            </strong>
          </p>
          <p>
            All matters relating to the Website and these Terms of Use, and any
            dispute or claim arising therefrom or related thereto (in each case,
            including non-contractual disputes or claims), shall be governed by
            and construed in accordance with the laws of the State of New Jersey
            without regard to principles of conflicts or choice of law that would
            defer to the substantive laws of any other jurisdiction.
          </p>
          <p>
            Any suit, claim, action, or proceeding arising out of, or related to,
            these Terms of Use or the Website shall be instituted exclusively in
            the federal courts of the United States located in Newark, New Jersey
            or the courts of the State of New Jersey, located in Middlesex County,
            New Jersey, although we retain the right to bring any suit, claim,
            action, or proceeding against you for breach of these Terms of Use in
            your country of residence or any other relevant country. You waive any
            and all objections to the exercise of jurisdiction over you by such
            courts and to venue in such courts. &nbsp;You and we each waive any
            right to a jury trial.
          </p>
          <p>
            <strong>
              27.{" "}
              <u>
                Prohibition of Class and Representative Actions and
                Non-Individualized Relief
              </u>
            </strong>
          </p>
          <p>
            YOU AND PALLETTRADER AGREE THAT YOU WILL NOT BRING CLAIMS AGAINST
            PALLETTRADER AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS, OR
            REPRESENTATIVE OR PRIVATE ATTORNEY GENERAL ACTION OR PROCEEDING.
            &nbsp;
          </p>
          <p>
            <strong>
              28. <u>Limitation on Time to File Claims</u>
            </strong>
          </p>
          <p>
            ANY CAUSE OF ACTION OR CLAIM YOU MAY HAVE ARISING OUT OF OR RELATING
            TO THESE TERMS OF USE OR THE WEBSITE MUST BE COMMENCED WITHIN ONE (1)
            YEAR AFTER THE CAUSE OF ACTION ACCRUES; OTHERWISE, SUCH CAUSE OF
            ACTION OR CLAIM IS PERMANENTLY BARRED.
          </p>
          <p>
            <strong>
              29. <u>Waiver and Severability</u>
            </strong>
          </p>
          <p>
            No waiver by PalletTrader of any term or condition set out in these
            Terms of Use shall be deemed a further or continuing waiver of such
            term or condition or a waiver of any other term or condition, and any
            failure of PalletTrader to assert a right or provision under these
            Terms of Use shall not constitute a waiver of such right or provision.
          </p>
          <p>
            In the event that any portion of these Terms of Use is held invalid or
            unenforceable for any reason, said invalidity or unenforceability
            shall not affect the other portions of these Terms of Use, and these
            Terms of Use shall be carried out as if such invalid or unenforceable
            provision, or part thereof, had been reformed, and any court of
            competent jurisdiction is authorized to so reform such invalid or
            unenforceable provision, or part thereof, so that it would be valid,
            legal and enforceable to the fullest extent permitted by applicable
            law.&nbsp;
          </p>
          <p>
            <strong>
              30. <u>Entire Agreement</u>
            </strong>
          </p>
          <p>
            The Terms of Use, our Privacy Policy, and the Terms and Conditions for
            Buyers and Sellers constitute the sole and entire agreement between
            you and PalletTrader regarding the Website and the services provided
            by PalletTrader and supersede all prior and contemporaneous
            understandings, agreements, representations, and warranties, both
            written and oral, regarding the Website and the services provided by
            PalletTrader.&nbsp;
          </p>
          <p>
            <strong>
              31. <u>Your Comments and Concerns</u>
            </strong>
          </p>
          <p>
            The Website is operated by Delancey Street Pallet Traders LLC, 110
            Sylvania Place, South Plainfield, NJ 07080.
          </p>
          <p>
            All notices of copyright infringement claims should be sent to the
            Copyright Agent designated in these Terms of Use in the manner set
            forth herein.
          </p>
          <p>
            All other feedback, comments, requests for technical support, and
            other communications relating to the Website should be directed to:
            &nbsp;support@pallettrader.com.
          </p>
        </Container>
        <LandingFooter isBackgroundWhite={true} />
      </PublicLayout>
    </>
  );
};

export default TermsOfUse;
